import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<rect x=".5" y=".5" width="23" height="23" rx="11.5"/> <rect x=".5" y=".5" width="23" height="23" rx="11.5" stroke="#243E81"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 11.5V5.856c0-.289.224-.523.5-.523s.5.234.5.523V11.5h5.644c.289 0 .523.224.523.5s-.234.5-.523.5H12.5v5.644a.51.51 0 0 1-.5.523.51.51 0 0 1-.5-.523V12.5H5.856a.51.51 0 0 1-.523-.5c0-.276.234-.5.523-.5z" fill="#243E81"/>' }
  })
);